<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h1>LIST OF TABLES</h1>
<p class="tocitem" style="margin-top:50pt"><span href="#/html/13_chap6#table1" title="Link target outside of Sample">Table 1 Hardways Set: Locations of Numbers</span></p>
<p class="tocitem"><span href="#/html/13_chap6#table2" title="Link target outside of Sample">Table 2 Field Bets for Various Sets</span></p>
<p class="tocitem"><span href="#/html/13_chap6#table3" title="Link target outside of Sample">Table 3 Hard Four and Ten for Various Sets</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table4" title="Link target outside of Sample">Table 4 Hardways Set</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table5" title="Link target outside of Sample">Table 5 3-V Set</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table6" title="Link target outside of Sample">Table 6 2-V Set</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table7" title="Link target outside of Sample">Table 7 S-6 Set (With 5-5)</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table8" title="Link target outside of Sample">Table 8 S-6 Set (With 4-4)</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table9" title="Link target outside of Sample">Table 9 S-6 Set (With Sevens)</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table10" title="Link target outside of Sample">Table 10 X-6 Set (5-4 on Near)</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table11" title="Link target outside of Sample">Table 11 X-6 Set (5-3 on Near)</span></p>
<p class="tocitem"><span href="#/html/19_appendix#table12" title="Link target outside of Sample">Table 12 Elevens Set</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_listoftables.vue?63bd451b